import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { getSingleMusicDataIfNeeded, setNotFound } from '../actions/MusicSingleActions';
import MusicSinglePage from '../components/MusicSingleComponent';
import {
    playMediaFromSourceWithMeta,
    pauseMediaPlayer,
    playMediaPlayer,
} from '../../aovivoBar/actions/MediaPlayerActions';
import { setPlaylist } from '../../../common/Playlist/actions/PlaylistActions';

const mapStateToProps = (state) => {
    const aovivoBar = state.aovivoBar;
    const isLive = aovivoBar.MediaPlayer.isLive;
    const music = isLive === 'otherMedia'
        ? aovivoBar.NowPlaying.music
        : aovivoBar.NowPlaying.musicLive;

    return {
        singleMusicData: state.musics.musicSingle.singleMusicData,
        news: state.musics.musicSingle.news,
        isRelatedNews: state.musics.musicSingle.isRelatedNews,
        currentSources: aovivoBar.MediaPlayer.currentSources,
        playerStatus: aovivoBar.MediaPlayer.playerStatus,
        notFound: state.musics.musicSingle.notFound,
        isLoading: state.musics.musicSingle.isLoading,
        breakpoint: state.breakpointReducer,
        isLive,
        playerSong: music.song,
        playerArtist: music.artist,
    };
};
const mapDispatchToProps = (dispatch) => ({
    getSingleMusicDataIfNeeded: (artist, music) => dispatch(getSingleMusicDataIfNeeded(artist, music)),
    playMediaFromSourceWithMeta: (src, meta) => dispatch(playMediaFromSourceWithMeta(src, meta)),
    pauseMediaPlayer: () => dispatch(pauseMediaPlayer()),
    playMediaPlayer: () => dispatch(playMediaPlayer()),
    setNotFound: (notFound) => {
        dispatch(setNotFound(notFound));
    },
    setPlaylist: (playlistType, trackList, currentIndex, currentMusicId) => dispatch(
        setPlaylist(playlistType, trackList, currentIndex, currentMusicId),
    ),
});
const MusicSingleContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(MusicSinglePage);

export default withRouter(MusicSingleContainer);
